import React, { useEffect, useState } from 'react';
import '../styles/insights.css';
import Apis from '../services/apis';

const News = () => {
  const apis = new Apis();
  const [loading, setLoading] = useState(true);
  let roles = localStorage.getItem("roles");
  roles = roles ? JSON.parse(roles) : [];
  const [clients, setClients] = useState([]);
  const [orgs,setOrgs] = useState([]);
  const username = localStorage.getItem("user_name") || "";
  const [isMobile, setIsMobile] = useState(false);

  const [marketNews,setMarketNews] = useState([]);

  const isClient = roles.some(
    (role) =>
      role.role_name === "Terminal Client"
  );  

  const [trustName,setTrustName] = useState(isClient?username:'Select Client');
  const [showClientSelector, setShowClientSelector] = React.useState(false);
  const [org,setorg] = useState('Select Company');
  const [showOrgSelector, setShowOrgSelector] = React.useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [Allinsights, setAllInsights] = useState([]);

  const isTerminalOfficer = roles.some(
    (role) =>
      role.role_name === "Terminal Officer"
  );  

  const isAdmin = roles.some(
    (role) =>
      role.role_name === "Admin"
  );  


  useEffect(() => {
    if(isClient)
    {
      fetchData(localStorage.getItem("user_id"));
    }
    else if(isTerminalOfficer)
      {
      getUsers()
      fetchNewsData([])
    }
    else if(isAdmin)
    {
      getOrgs()
    }
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const convertArrayToTags = (arr) =>
    arr.map(label => ({
      entity_type: "tag",
      entity_value: label
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
    }));

  const fetchData = async (id) => {
    try {
      const response = await apis.getCategoriesForUser(id);
      let filters = convertArrayToTags(response.data.data);
      fetchNewsData(filters)
    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while fetching categories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching categories");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchNewsData = async (data) => {
    try {
      let body ={
        "from": new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
        "to":new Date().toISOString().split('T')[0],
        "filters": data
      }
      const response = await apis.getStories(body);

    

      let allcat = await getCategories();

      const mapfun =(data)=>
        {
            if(data == "ALL"){
              return "ALL"
            }
            if(data == "NFT"){
              return "NFT"
            }
            if(data == "ART"){
              return "ART"
            }
            if(data == "COLLECTIBLES"){
              return "SECURITIZED COLLECTIBLES"
            }
            if(data == "WATCHES"){
              return "LUXURY TIMEPIECES"
            }
            if(data == "CARS"){
              return "EXOTIC AUTOMOBILES"
            }
            if(data=="HANDBAGS"){
              return "DESIGNER HANDBAGS"
            }
            else{
              return data
            }
      }

    const categoryMap = allcat.reduce((acc, c) => {
      acc[mapfun(c.code.replaceAll("_"," "))] = c;
      return acc;
    }, {});

    let news = await  mapStoriesToHeadlineItems(response.data.stories,categoryMap,mapfun);
    console.log("Mapped News:", news);
    setMarketNews(news);
    setAllInsights(news);
    const map = {};
    news.forEach(s => {
      map[s.category] = (map[s.category] || 0) + 1;
    });

      setCategories([
        { id: 'all', name: 'All', count: news.length },
        ...Object.entries(map).map(([key, count]) => ({
          id: key,
          name: key.charAt(0).toUpperCase() + key.slice(1),
          count,
          categoryColor: categoryMap[key]?.color || '#CCCCCC',

        })),
      ]);
      setLoading(false);

    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while stories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching stories");
      }
    } finally {
      setLoading(false);
    }
  };

  const formatPublishedDate = (dateStr) => {
    if (!dateStr) return '';
  
    const date = new Date(dateStr);
    const now = new Date();
  
    // normalize to date-only
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
  
    const itemDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  
    // ✅ Today → show time
    if (itemDate.getTime() === today.getTime()) {
      return (
      // date.toLocaleTimeString([], {
      //   hour: '2-digit',
      //   minute: '2-digit',
      // })+
      ("Today")
    )}
  
    // ✅ Yesterday
    if (itemDate.getTime() === yesterday.getTime()) {
      return 'Yesterday';
    }
  
    // ✅ Older → show date
    return date.toLocaleDateString([], {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  async function mapStoriesToHeadlineItems(items = [],categoryMap,mapfun) {


    return items.map((item, index) => {
      // Extract headline from markdown body
      const body = item?.story?.body || '';

      const headlineMatch = body.match(/^#\s+(.*)/m);
      const headline = headlineMatch ? headlineMatch[1].trim() : '';

      const titleMatch = body.match(/^Title:\s*(.*)$/m);
      const title = titleMatch?.[1].trim() || '';

      const urlMatch = body.match(/^URL:\s*(https?:\/\/\S+)$/m);
      const url = urlMatch?.[1].trim() || '';

      const descriptionMatch = body.match(/^Description:\s*([\s\S]*?)$/m);
      const description = descriptionMatch?.[1];

      const sourceurl = item.evidence_ref?.source_urls[0] || ""
      const category = item?.story?.classification?.asset_class || '';
      // Extract source from filters
      const sourceFilter = item.filters?.find(f => f.key === 'source_data');
      const source = sourceFilter?.allowed?.[0] || '';
      
  
        console.log("cmap===",categoryMap)

      let ncat = mapfun(category?.toUpperCase().replaceAll("_"," "))

  
      return {
        id: item.story_id ?? index + 1,
        date: formatPublishedDate(item.published_date) || '',
        headline,
        source,
        sourceurl,
        category:ncat,
        title,
        url,
        description,
        categoryColor: categoryMap[ncat]?.color || '#CCCCCC',
      };
    });
  }

  const getUsers = () => {
    apis.getusers()
    .then((response) => {
        let data = response.data.data.users
        let arr = [];
        data.forEach(user => {
          if(user.roles.filter(r => r.name === "Terminal Client").length>0)
          {
            arr.push({
              id: user.id,
              name: user.name,
            })
          }
        });
        setClients(arr)
        // setLoading(false)
    })
    .catch((error) => {
        if (error.response && error.response.status === 404) {
            setLoading(false)
            alert("Error occurred while fetching categories "+ error.response.data.message);
        } else {
            // Handle other errors
            console.error("Error:", error);
            alert("Error occurred while fetching asset data");
        }
    });
  }

  const getOrgs = () => {
    apis.getTerminalOrgs()
    .then((response) => {
        let data = response.data.organizations;
        setOrgs(data)
        setLoading(false)
    })
    .catch((error) => {
        if (error.response && error.response.status === 404) {
            setLoading(false)
            alert("Error occurred while fetching categories "+ error.response.data.message);
        } else {
            // Handle other errors
            console.error("Error:", error);
            alert("Error occurred while fetching asset data");
        }
    });
  }

  const getCategories = async () => {
    try {
      const response = await apis.getCategories();
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while fetching categories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching asset data");
      }
      return [];
    }
  };


  if(!loading)
  { return (
    <div className="luxury-dashboard">

      {/* Market News Section */}
      <section className="news-section" >
      <h2 className="news-title">News</h2>
      <p className="subtitle">Latest news related to client holdings</p>
        <div style={{display:'flex',width:'100%',justifyContent:'space-between',gap:'10px'}}>
         {isAdmin&&( <div className="trust-header" style={{ position: 'relative',minWidth:'50%' }}>
            <div className="trust-info">
              <span className="viewing-label">VIEWING COMPANY</span>
              <span className="trust-name">{org}</span>
            </div>

            <button
              className="change-btn"
              onClick={() => setShowOrgSelector(prev => !prev)}
            >
              Change <span className="arrow">↗</span>
            </button>

            {showOrgSelector && (
              <div className="client-dropdown">
                {orgs.map(client => (
                  <div
                    key={client.id}
                    className="client-option"
                    onClick={() => {
                      localStorage.setItem("selected_org_id",client.id)
                      setorg(client.name);
                      setShowOrgSelector(false);
                      setLoading(true);
                      getUsers()
                    }}
                  >
                    {client.name}
                  </div>
                ))}
              </div>
            )}
          </div>)}

          <div className="trust-header" style={{ position: 'relative',minWidth:isAdmin?'50%':'100%' }}>
            <div className="trust-info">
              <span className="viewing-label">VIEWING</span>
              <span className="trust-name">{trustName}</span>
            </div>

            <button
              className="change-btn"
              onClick={() => setShowClientSelector(prev => !prev)}
            >
              Change <span className="arrow">↗</span>
            </button>

            {showClientSelector && (
              <div className="client-dropdown">
                {clients.map(client => (
                  <div
                    key={client.id}
                    className="client-option"
                    onClick={() => {
                      setTrustName(client.name);
                      setShowClientSelector(false);
                      setLoading(true);
                      fetchData(client.id);
                    }}
                  >
                    {client.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      
        <div className="category-filters" style={{marginTop:0}}>
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
              onClick={() => {
                setMarketNews([]);
                setSelectedCategory(cat.id)
                let arr = Allinsights.filter( i => i.category === cat.id)  
                if(cat.id === 'all'){
                  arr = Allinsights
                }
                console.log(arr)
                setMarketNews(arr)    
              }}
              style={{fontSize:12,
                ...selectedCategory != cat.id&&{
                backgroundColor: `${cat.categoryColor}22`,
                color: cat.categoryColor,
                borderColor: `${cat.categoryColor}`,
              }}}
            >
              {cat.name?.toUpperCase().replaceAll('_',' ')}
              <span className="filter-count" style={{...selectedCategory != cat.id&&{color:cat.categoryColor}}}>{cat.count}</span>

            </button>
          ))}
        </div>


        {/* <div className="news-table">
          <div className="news-table-header">
            <div className="col-time">DATE</div>
            <div className="col-source">SOURCE</div>
            <div className="col-headline">HEADLINE</div>
          </div>

          <div className="news-table-body">
            {marketNews.map((news) => (
              <div  key={news.id} className="news-row">
                <div className="col-time">{news.date}</div>
                <div className="col-source">{news.source}</div>
                <div 
                  onClick={()=>window.open(news.sourceurl, '_blank', 'noopener,noreferrer')} 
                  className="col-headline"
                >
                  {news.headline}
                </div>
              </div>
            ))}
          </div>
        </div> */}

        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "1px",
          background: "#2a2a2a"
        }}>
          {marketNews.map((lot, index) => (
            <div
              key={lot.id}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "30px",
                background: "#0a0a0a",
                transition: "all 0.3s ease",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#1a1a1a";
                e.currentTarget.style.transform = "translateX(4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#0a0a0a";
                e.currentTarget.style.transform = "translateX(0)";
              }}
              onClick={()=>window.open(lot.sourceurl, '_blank', 'noopener,noreferrer')} 
            >
            

              {/* <div style={{
                width: "180px",
                height: "120px",
                flexShrink: 0,
                overflow: "hidden",
                background: "#1a1a1a",
                position: "relative"
              }}>
                <img
                  src={lot.url}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: "0.85"
                  }}
                />
                <div style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(to right, transparent 50%, rgba(10,10,10,0.5) 100%)"
                }} />
              </div> */}
              {!isMobile&&(<div style={{width:100}}> {lot.date}</div>)}

              <div
                className="category-badge"
                style={{
                  marginTop:'10px',
                  marginLeft:20,
                  minWidth:'100px',
                  maxWidth:'100px',
                  backgroundColor: `${lot.categoryColor}22`,
                  color: lot.categoryColor,
                  borderColor: `${lot.categoryColor}`,
                  // position:'absolute',
                  // top:0,left:10,
                  fontSize:10,
                  justifyContent:'center',
                  alignItems:'center'
                }}
              >
            
                <span style={{color:`${lot.categoryColor}`}}>{lot.category}</span>
              </div>
              <div style={{
                flex: 1,
                padding: isMobile?"0px":"0 40px",
                display: "flex",
                flexDirection: "column",
                gap: "12px"
              }}>                

                <div style={{
                  fontSize: "18px",
                  color: "#fff",
                  lineHeight: "1.5"
                }}>
                  {lot.headline}
                </div>

                <div style={{
                  fontSize: "15px",
                  color: "#999",
                  lineHeight: "1.5"
                }}>
                  {lot.description}
                </div>

                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "13px",
                  color: "#666",
                  fontFamily: "'Montserrat', sans-serif",
                  marginTop: "4px",
                  flexWrap: "wrap"
                }}>
                  {/* <span>Date : {lot.date}</span> */}
                  {/* <span style={{ color: "#333" }}>•</span> */}
                  {/* <span style={{color:'orange',border:'1px solid orange',borderRadius:20,padding:10}}>{lot.category?.toUpperCase()?.replaceAll("_"," ")}</span> */}
                 
                  {/* <div className="card-footer">
                    <span className="card-index">{lot.category?.toUpperCase()?.replaceAll("_"," ")}</span>
                  </div> */}

                  
                 {isMobile&&( <span>{lot.source}</span>)}
                 {isMobile&&( <span>{lot.date}</span>)}
                 
                </div>
              </div>

              {/* Price */}
              {!isMobile&&(<div style={{
                textAlign: "right",
                paddingRight: "20px"
              }}>
                <div style={{
                  fontSize: "12px",
                  color: "#666",
                  marginTop: "4px",
                  letterSpacing: "1px",
                  fontFamily: "'Montserrat', sans-serif",
                  textTransform: "uppercase"
                }}>
                  {lot.source}
                </div>
              </div>)}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
  }
  if (loading) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  }
};

export default News; 